import {reportYear} from '../../util/util'
import InsuranceESGRankingTable from '../components/InsuranceESGRankingTable'
import InsuranceESGTable from '../../esg/components/ESGRatingTable'
export default {
  components: {'ins-esg-ranking-table': InsuranceESGRankingTable, 'ins-esg-table': InsuranceESGTable},
  data() {
    return {
      report_year_list: [],
      year: null,
      industry: null,
      selectEvent:false,
      rating: null,
    }
  },
  methods: {
    generateReport(){
      let self = this
      reportYear.esg_report_month().then(result => {
        self.report_year_list =result.report_list
        self.year=self.report_year_list[0]
      })
    },
    selectIndustry(industry, rating){
      this.industry = industry
      this.rating = rating
      this.selectEvent = !this.selectEvent
    },
  },
  created() {
    this.generateReport()
  },
  watch: {
    year: function () {
      this.$store.commit('esg/esgReport', {year: this.year})
    }
  }
}



// WEBPACK FOOTER //
// ./src/insurance_esg/js/insurance_esg_ranking.js